// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report * {\n    border: 0.5px rgba(0, 0, 0, 0.5) !important;\n    /* Define a cor e a opacidade das bordas */\n}", "",{"version":3,"sources":["webpack://src/pages/Reports/Attendance/styles.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,0CAA0C;AAC9C","sourcesContent":[".report * {\n    border: 0.5px rgba(0, 0, 0, 0.5) !important;\n    /* Define a cor e a opacidade das bordas */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
